module.exports = __webpack_public_path__ + "img/fsni_2.11dfaab8.jpg";